// Build-time feature flags (REACT_APP_* baked in by CRA). Default off: a flag is
// enabled only when its env var is exactly the string 'true'.

export const isQcOrdersEnabled = (): boolean =>
  process.env.REACT_APP_ENABLE_QC_ORDERS === 'true';

// True only in the dev build. Gates dev-only access (e.g. the `dev` role's
// Catalog visibility) so `dev` users never see prod resources.
export const isDevBuild = (): boolean =>
  process.env.REACT_APP_STAGE === 'dev';

export const isCatalogV2Enabled = (): boolean =>
  process.env.REACT_APP_ENABLE_CATALOG_V2 === 'true';

// Single source of truth for "can this role reach the Catalog module" —
// used by the sidebar link, the module route guard, and the orders sub-route.
export const canSeeCatalog = (access: string | null | undefined): boolean =>
  access === 'admin' || (access === 'dev' && isDevBuild());

// Title Orders is also released to the 'full' group (who can Associate, like admins).
export const canUseTitleOrders = (access: string | null | undefined): boolean =>
  canSeeCatalog(access) || access === 'full';

export const canAssociateVideo = (access: string | null | undefined): boolean =>
  access === 'admin' || access === 'full';
